import { getMatchesForLeague } from './get-matches-for-league';
import { LEAGUE_CONFIGS } from './league-config';

/*
 * Obtiene los datos completos de un partido específico
 */
export const getMatchData = (formData: any, creativityType?: string) => {
  const { sport: formSport, league: formLeague, round, team1, team2 } = formData;

  // Inferir league del creativityType si no viene
  const league = formLeague || creativityType?.split('/')[3];

  if (!league || !LEAGUE_CONFIGS[league]) return null;

  const config = LEAGUE_CONFIGS[league];

  // Inferir sport si no viene (para miniaturas)
  const isMiniatura = creativityType?.includes('miniatura');
  const sport = formSport || (isMiniatura ? config.sport : undefined);

  if (sport !== config.sport) return null;

  const matches = getMatchesForLeague(config.sport, league);
  if (!matches || matches.length === 0) return null;

  // Filtrar por round si es necesario
  const filteredMatches = config.requiresRound && round ? matches.filter(m => m.round === round) : matches;

  // Buscar el partido exacto
  const match = filteredMatches.find(m => m.team1 === team1 && m.team2 === team2);

  return match || null;
};
